<template>
  <div class="content-warp">
    <a-row :gutter="24">
      <a-col :span="6">
        <div class="content-panle bg-white" style="height:670px">
          <SingleTreeWithSearch
            ref="treeArea"
            :selectedData="targetOrg"
            :mixNodeName="false"
            @update:selectedOrg="handleSelectedOrg"
          ></SingleTreeWithSearch>
        </div>
      </a-col>

      <a-col :span="18">
        <div class="content-panle bg-white">
          <div class="table-operation-area">
            <div class="btn-area-inline">
              <a-button type="primary" :disabled="!targetOrg" @click="handleToAddPerson">{{$t('personalMana.addBtn')}}</a-button>
              <a-button type="primary" :disabled="!targetOrg" @click="()=>{importModalVisible=true;}">{{$t('personalMana.bulkImportBtn')}}</a-button>
              <a-button type="primary" :disabled="!(selectedRowKeys.length>=2)" @click="handleToAuthPersonalBatch">{{$t('personalMana.volumeLicenseesBtn')}}</a-button>
              <a-button type="primary" :disabled="!selectedRowKeys.length" @click="handleShowAuthModal">{{$t('personalMana.expiryDateBtn')}}</a-button>
              <a-button type="danger" :disabled="!(selectedRowKeys.length>=2)" @click="handleDeletePersonsBatch">{{$t('personalMana.batchDeleteBtn')}}</a-button>
            </div>
            <a-form class="search-form" layout="inline" :form="listSearchForm" @submit.prevent="handleSearch">
              <a-form-item style="width: calc(100% - 115px)">
                <a-input
                  :disabled="!targetOrg"
                  type="text"
                  v-decorator="['searchNameOrId']"
                  :placeholder="$t('personalMana.searchTxt')" >
                  <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
                </a-input>
              </a-form-item>
              <a-form-item style="margin-right:0">
                <a-button type="primary" html-type="submit" :disabled="!targetOrg" :loading="targetOrg && loading">
                  {{$t('personalMana.searchBtn')}}
                </a-button>
              </a-form-item>
            </a-form>
          </div>

          <TableTips
            :total="pagination.total"
            :selected="selectedRowKeys.length"
            @clearAllSelected="() => {selectedRowKeys = []; selectedRowItems = []}"
          />
          <a-table
            class="table-area"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: handleTableItemSelected }"
            :columns="tableColumns"
            :dataSource="tableData"
            :pagination="pagination"
            :loading="loading"
            @change="handleTableChange"
          >
            <template slot="name" slot-scope="text, record">
              {{record.name}}
              <a-icon v-if="record.isBindingWxApplet" type="wechat" theme="twoTone" two-tone-color="#52c41a"/>
            </template>

            <template slot="expiryDate" slot-scope="text, record">
              <template v-if="record.authStart && record.authEnd">
                <span v-if="moment(record.authEnd)<moment()" style="color: #F5222D">{{$t('personalMana.listAuthExpired')}}</span>
                <span v-else-if="moment(record.authEnd).diff(moment(), 'years')>=99"  style="color: #1890FF">{{$t('personalMana.listAuthPermanent')}}</span>
                <span v-else>
                  {{record.authStart.split(' ')[0]}}
                  {{$t('personalMana.listAuthTerm')}}
                  {{record.authEnd.split(' ')[0]}}
                </span>
              </template>
              <span v-else> -- </span>
            </template>

            <template slot="operation" slot-scope="text, record">
              <div v-if="record.operation">
                <a
                  class="operation-botton"
                  v-for="item in record.operation"
                  :key="item.type"
                  :disabled="item.disabled"
                  :style="{color: item.color || '#1890ff', 'word-break': 'keep-all'}"
                  @click="item.callback(record)"
                >
                  {{$t(item.type)}}
                </a>
              </div>
            </template>
          </a-table>
        </div>
      </a-col>
    </a-row>
    <!-- 设置授权时间模态框 -->
    <a-modal
      :title="authRangeModalTitle"
      :visible="authRangeModalVisible"
      :okText="$t('personalMana.submitBtn')"
      :cancelText="$t('personalMana.cancelBtn')"
      @ok="handleSubmitAuthPeriod"
      :confirmLoading="confirmAuthRangeLoading"
      @cancel="()=>{authRangeModalVisible=false}"
      :afterClose="handleAuthRangeModalHide"
    >
      <a-form-model
        ref="authRangeForm"
        :model="authRangeForm"
        :rules="authRangeFormRules"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 19 }"
      >
        <a-form-model-item :required="!authRangeForm.forever" :label="$t('personalMana.expiryDateTxt')" prop="dateRange">
          <a-range-picker
            v-model="authRangeForm.dateRange"
            format="YYYY-MM-DD"
            :locale="datePickerLang"
            :placeholder="[$t('personalMana.dateStartTxt'), $t('personalMana.dateEndTxt')]"
            :ranges="dateRangesBtn"
            :disabled="authRangeForm.forever"
          />
        </a-form-model-item>
        <a-form-model-item :label="$t('personalMana.permanentTxt')" prop="forever">
          <a-switch v-model="authRangeForm.forever"  @change="handleForeverAuthSwitchChange"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 批量导入模态框 -->
    <a-modal
      :title="$t('personalMana.bulkImportTxt')"
      :visible="importModalVisible"
      :okText="$t('personalMana.confirmBtn')"
      :cancelText="$t('personalMana.cancelBtn')"
      @ok="()=>{importModalVisible=false}"
      @cancel="()=>{importModalVisible=false}"
      :maskClosable="false"
      :afterClose="handleImportModalHide"
    >
      <a-form-model
        ref="importForm"
        :model="importForm"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-item :label="$t('personalMana.improtInstructions')">
          <a v-if="lang === 'zh_CN'" download="导入人员信息说明.zip" :href="path+'导入人员信息说明.zip'" target="_blank">导入人员信息说明.zip</a>
          <a v-else download="improtInstructions.txt" :href="path+'improtInstructions.txt'" target="_blank">Improt Instructions.txt</a>
        </a-form-item>
        <a-form-item :label="$t('personalMana.importHasSameData')" prop="sameHandleState">
          <a-radio-group v-model="importForm.sameHandleState" button-style="solid">
            <a-radio-button :value="1">{{$t('personalMana.radioRecover')}}</a-radio-button>
            <a-radio-button :value="2">{{$t('personalMana.radioThrowErr')}}</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item :label="$t('personalMana.importFileTxt')" prop="files">
          <a-upload
            :action="`/face/web/person/batch_import_people?sameHandleState=${importForm.sameHandleState}`"
            method="post"
            name="file"
            accept=".zip"
            :beforeUpload="()=>{importFiles=[];importFile=null;importFailArr=[];}"
            :remove="handleImportRemove"
            :fileList="importFiles"
            :data="{orgId: targetOrg&&targetOrg.id||null }"
            @change="handleImportChange"
          >
            <a-button> <a-icon type="upload" /> {{$t('personalMana.uploadFileBtn')}} </a-button>
          </a-upload>
        </a-form-item>
        <a-form-item :label="$t('personalMana.importResultTxt')" v-if="importFile">
          <p>
            <span style="color:#52c41a;display: block">{{$t('personalMana.importSuccess')}}{{importFile.response.collection[0].successCount}}</span>
            <span style="color:#f5222d;display: block">
              {{$t('personalMana.importFail')}}{{importFile.response.collection[0].failCount}}
              <span v-if="importFailArr.length" style="margin-left:5px;cursor: pointer;" @click="handleDownloadImportErr">
                ( {{$t('personalMana.downloadImportErrBtn')}} <a-icon type="download" /> )
              </span>
            </span>
          </p>
        </a-form-item>
      </a-form-model>
    </a-modal>

    <!-- 显示二维码 -->
    <a-modal
      :title="$t('personalMana.QRCodeTitle')"
      :visible="QRCodeModalVisible"
      :footer='null'
      @cancel="()=>{QRCodeModalVisible=false}"
      :afterClose="()=>{codeString='';codeName=''}"
    >
      <QRCode v-if="codeString" :codeString="codeString" :codeName="codeName">
        <template v-slot:describe>
          <p style="text-align:center;color:#fa8c16">{{$t('personalMana.QRCodeDesc')}}</p>
          <p style="text-align:center;color:#1890ff">{{$t('personalMana.QRCodeValidityDesc')}}</p>
        </template>
      </QRCode>
    </a-modal>
  </div>

</template>

<script>
import SingleTreeWithSearch from '@/components/SingleTreeWithSearch';
import QRCode from '@/components/QRCode';
import TableTips from '@/components/TableTips';
import moment from 'moment';
import { mapState } from 'vuex';
import { parsePromiseAllRes, deleteSelectedRow } from '../../utils/utils';
import { getPersons, deletePerson, createQRCode, unbindWeChat } from '@/api/personalMana';
import { updateAuthorizedPeriod } from '@/api/authMana';

export default {
  name: 'personalManaIndex',
  components: {
    SingleTreeWithSearch,
    QRCode,
    TableTips
  },
  inject: ['datePickerLang'],
  data() {
    return {
      path: process.env.BASE_URL,

      targetOrg: null, // 组织树中选中的对象

      listSearchForm: this.$form.createForm(this),
      searchNameOrId: '',

      loading: false, // 列表内容是否在加载中
      tableData: [], // 列表数据源
      tableColumns: this.getTableColumns(), // 列表表头项
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      selectedRowKeys: [], // 列表多选钩中项的Id数组
      selectedRowItems: [], // 列表多选钩中项的数组

      // 设置授权有效期
      authRangeModalVisible: false,
      confirmAuthRangeLoading: false,
      authRangeModalTitle: '',
      authRangeForm: {
        dateRange: [],
        forever: false
      },
      authRangeFormRules: {
        dateRange: [
          { validator: this.handlevalidAuthRange }
        ]
      },
      // 有效期 date-range-picker
      dateRangesBtn: this.getDateRangesBtn(),

      // 导入
      importForm: {
        sameHandleState: 2
      },
      importModalVisible: false,
      importFiles: [],
      importFile: null,
      importFailArr: [],

      // 二维码
      QRCodeModalVisible: false,
      codeString: '',
      codeName: ''
    }
  },
  computed: {
    ...mapState(['lang'])
  },
  watch: {
    lang: function (lang) {
      this.tableColumns = this.getTableColumns()
      this.dateRangesBtn = this.getDateRangesBtn()
    }
  },
  created() {
  },
  activated() {
    // if (this.tableData.length) {
    this.getPersonalListData()
    // }
  },
  methods: {
    moment,

    // 获取表头项名
    getTableColumns() {
      return [
        {
          title: this.$t('personalMana.listName'),
          dataIndex: 'name',
          width: '10%',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: this.$t('personalMana.listIDNumber'),
          dataIndex: 'idNumber',
          width: '20%'
        },
        {
          title: this.$t('personalMana.listPhone'),
          dataIndex: 'mobile',
          width: '15%'
        },
        {
          title: this.$t('personalMana.listExpiryDate'),
          dataIndex: 'expiryDate',
          width: '20%',
          scopedSlots: { customRender: 'expiryDate' }
        },
        {
          title: this.$t('personalMana.listOperation'),
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },
    // 获取时间段选择插件快捷按钮内容
    getDateRangesBtn() {
      const btns = {}
      btns[this.$t('personalMana.comingWeekBtn')] = [this.moment(), this.moment().add(6, 'days')]
      btns[this.$t('personalMana.comingMonthBtn')] = [this.moment(), this.moment().add(1, 'months')]
      btns[this.$t('personalMana.comingHalfYearBtn')] = [this.moment(), this.moment().add(6, 'months')]
      btns[this.$t('personalMana.comingYearBtn')] = [this.moment(), this.moment().add(1, 'years')]

      return btns
    },
    // 选定一个组织
    handleSelectedOrg(data) {
      // console.log('-------handleSelectedOrg--------', data);
      this.targetOrg = data
      this.pagination.current = 1
      deleteSelectedRow(undefined, this.selectedRowKeys, this.selectedRowItems)
      this.getPersonalListData()
    },

    // 搜索列表
    handleSearch() {
      this.listSearchForm.validateFields((err, values) => {
        if (!err) {
          this.searchNameOrId = values.searchNameOrId
          this.pagination.current = 1
          deleteSelectedRow(undefined, this.selectedRowKeys, this.selectedRowItems)
          this.getPersonalListData()
        }
      });
    },

    // 获取人员列表列表数据
    async getPersonalListData(page) {
      try {
        this.loading = true
        const res = await getPersons({
          deptId: this.targetOrg.id,
          perPage: this.pagination.pageSize,
          page: page || this.pagination.current,
          keyword: this.searchNameOrId && this.searchNameOrId.trim(),
          searchChildren: false // 不查询子组织的人员
        })
        this.loading = false

        this.tableData = this.createPersonalTableData(res.data.collection)
        this.pagination.total = res.data.size
      } catch (error) {
        this.loading = false
      }
    },
    createPersonalTableData(data) {
      return data.map(item => {
        let authStart = item.authStart ? item.authStart.split(' ')[0] : '';
        let authEnd = item.authEnd ? item.authEnd.split(' ')[0] : '';
        return {
          key: item.id,
          id: item.id,
          name: item.name,
          isBindingWxApplet: item.isBindingWxApplet,
          idNumber: item.idNumber,
          mobile: item.phone || '--',
          deptFullName: item.deptFullName,
          createdAt: item.createdAt,
          // expiryDate: authStart && authEnd ? authStart + ' 至 ' + authEnd : '',
          authStart: item.authStart,
          authEnd: item.authEnd,
          expiryDateMoment: authStart && authEnd ? [moment(authStart), moment(authEnd)] : '',
          operation: [{
            type: 'personalMana.listBtnEdit',
            disabled: false,
            color: '',
            callback: this.handleToEditPersonal
          }, {
            type: 'personalMana.listBtnAuth',
            disabled: false,
            color: '#fa8c16',
            callback: this.handleToAuthPersonal
          }, {
            type: 'personalMana.listBtnDelete',
            disabled: false,
            color: '#f5222d',
            callback: this.handleDeletePerson
          }
          // , {
          //   type: item.isBindingWxApplet ? 'personalMana.listBtnUnbind' : 'personalMana.listBtnBind',
          //   disabled: false,
          //   color: '',
          //   callback: item.isBindingWxApplet ? this.handleUnboundWx : this.handleGetQRCode
          // }
          ]
        }
      })
    },
    // 点击分页时触发
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.getPersonalListData()
    },

    handleTableItemSelected(rowKeys, rowItems) {
      this.selectedRowKeys = rowKeys;
      this.selectedRowItems = rowItems;
    },

    // 新增人员
    handleToAddPerson() {
      this.$router.push({
        path: '/personal-mana/new',
        query: {
          oi: this.targetOrg.id,
          on: this.targetOrg.nameList.join(' ')
        }
      })
    },
    // 修改编辑人员
    handleToEditPersonal (data) {
      this.$router.push({
        path: '/personal-mana/edit',
        query: {
          pi: data.id
        }
      })
    },
    // 批量授权
    handleToAuthPersonalBatch() {
      const queryData = this.selectedRowItems.map(item => {
        const { id, name, idNumber, deptFullName } = item
        return { id, name, idNumber, deptFullName }
      })
      this.$router.push({
        path: '/personal-mana/auth-batch',
        query: { ps: JSON.stringify(queryData) }
      })
    },
    // 单个人员授权
    handleToAuthPersonal (data) {
      this.$router.push({
        name: 'personalManaAuth',
        params: { person: data }
      })
    },

    // 批量删除人员
    handleDeletePersonsBatch() {
      this.$confirm({
        title: new Function('count', this.$t('personalMana.batchDeleteWarning'))(this.selectedRowKeys.length),
        content: this.$t('personalMana.batchDeleteWarningDesc'),
        okText: this.$t('personalMana.confirmBtn'),
        cancelText: this.$t('personalMana.cancelBtn'),
        onOk: () => { this.deletePersonRquest(this.selectedRowKeys) },
        onCancel() {}
      });
    },
    // 单独删除
    handleDeletePerson(data) {
      this.$confirm({
        title: this.$t('personalMana.deleteWarning'),
        content: this.$t('personalMana.deleteWarningDesc'),
        okText: this.$t('personalMana.confirmBtn'),
        cancelText: this.$t('personalMana.cancelBtn'),
        onOk: () => { this.deletePersonRquest([data.id]) },
        onCancel() {}
      });
    },
    // 删除人员
    deletePersonRquest(idsArr) {
      const deletePromises = idsArr.map(item => this.getDeletePersonAxios(item))
      Promise.all(deletePromises).then(resArr => {
        // 处理 Promise.all 返回结果
        const { successRes } = parsePromiseAllRes(
          this,
          resArr,
          {
            successMsg: new Function('count', this.$t('personalMana.batchDeleteSuccess')),
            failMsg: new Function('count', this.$t('personalMana.batchDeleteFail')),
            targets: this.selectedRowItems.map(item => { return { id: item.id, name: item.name } })
          }
        )

        // 有删除成功的结果，则刷新列表
        if (successRes.length) this.refreshPersonTable(successRes.length)
      }).catch(err => {})
    },
    // 删除后刷新列表
    refreshPersonTable(successCount) {
      // 刷新列表
      // 若当前页未全部删除，则查询但前页；
      // 若当前页全部删除，则查询上一页；
      // 若当前为第一页，则查询第一页；
      if (this.tableData.length === successCount) {
        --this.pagination.current
      }
      this.getPersonalListData(this.pagination.current || 1);
    },
    // 删除人员的请求
    async getDeletePersonAxios(id) {
      try {
        const res = await deletePerson({ id })
        deleteSelectedRow(id, this.selectedRowKeys, this.selectedRowItems)
        return Promise.resolve({ res: res, targetId: id })
      } catch (error) {
        return Promise.resolve({ res: error, targetId: id })
      }
    },

    // 打开授权模态框
    handleShowAuthModal() {
      const selectedStr = new Function('count', this.$t('personalMana.expiryDateModalDesc'))(this.selectedRowKeys.length)
      this.authRangeModalTitle = this.$t('personalMana.expiryDateModal') + ' - ' + selectedStr

      this.authRangeModalVisible = true;
    },
    // 提交设置的授权时间
    handleSubmitAuthPeriod(e) {
      this.$refs.authRangeForm.validate(valid => {
        if (valid) {
          this.confirmAuthRangeLoading = true

          const authPeriodPromises = this.selectedRowKeys.map(item => this.getAuthPeriodAxios(item))
          Promise.all(authPeriodPromises).then(resArr => {
            this.authRangeModalVisible = false
            // 处理 Promise.all 返回结果
            const { successRes } = parsePromiseAllRes(
              this,
              resArr,
              {
                successMsg: new Function('count', this.$t('personalMana.setExpiryDateSuccess')),
                failMsg: new Function('count', this.$t('personalMana.setExpiryDateFail')),
                targets: this.selectedRowItems.map(item => { return { id: item.id, name: item.name } })
              }
            )

            if (successRes.length) this.getPersonalListData()
          }).catch(err => {
            this.confirmAuthRangeLoading = false
          })
        }
      })
    },

    async getAuthPeriodAxios(id) {
      try {
        const res = await updateAuthorizedPeriod({
          personId: id,
          authStart: this.authRangeForm.dateRange[0].format('YYYY-MM-DD') || null,
          authEnd: this.authRangeForm.dateRange[1].format('YYYY-MM-DD') || null
        })
        return Promise.resolve({ res: res, targetId: id })
      } catch (error) {
        return Promise.resolve({ res: error, targetId: id })
      }
    },
    // 关闭设置授权时间模态框
    handleAuthRangeModalHide(e) {
      this.confirmAuthRangeLoading = false;
      this.authRangeForm = { dateRange: [], forever: false };
      this.$refs.authRangeForm.clearValidate();
    },
    // 授权时间段校验
    handlevalidAuthRange(rule, value, callback) {
      if (!value.length && !this.authRangeForm.forever) {
        callback(this.$t('personalMana.expiryDateBlank'));
        return;
      }
      if (value[1].diff(value[0], 'years', true) > 1 && !this.authRangeForm.forever) {
        callback(this.$t('personalMana.expiryDateWarning'));
        return;
      }
      callback();
    },
    // 永久授权开关变动
    handleForeverAuthSwitchChange(data) {
      // console.log('----', data)
      this.$refs.authRangeForm.clearValidate();
      if (data) {
        this.authRangeForm.dateRange = [moment(), moment().add(100, 'years')];
      } else {
        this.authRangeForm.dateRange = [];
      }

    },

    // 导入人员信息
    handleImportChange(info) {
      if (info.file.status === 'uploading') {
        this.importFiles = info.fileList
      }

      if (info.file.status === 'done') {

        // console.log('--handleImportChange done--', info)

        this.$message.success(info.file.name + this.$t('personalMana.uploadSuccess'));

        this.importFile = info.file
        const { errorList } = info.file.response.collection[0]
        this.importFailArr = errorList || []
        // if (successCount) {
        //   this.listSearchForm.resetFields()
        //   this.pagination.current = 1
        //   this.getPersonalListData()
        // }
      } else if (info.file.status === 'error') {
        this.$message.error(info.file.name + this.$t('personalMana.uploadFail'));
        this.$message.error(info.file.response.message);
      }
    },
    handleImportRemove(file) {
      const index = this.importFiles.indexOf(file);
      const newFileList = this.importFiles.slice();
      newFileList.splice(index, 1);

      this.importFiles = newFileList;
      this.importFile = null;
      this.importFailArr = [];
    },
    handleImportModalHide() {
      this.importFiles = [];
      this.importFile = null;
      this.importFailArr = [];
    },
    handleDownloadImportErr() {
      var pom = document.createElement('a');
      var errString = '';
      this.importFailArr.forEach(function(item) {
        errString += item + '\r\n'
      })

      pom.setAttribute(
        'href',
        'data:text/plain;charset=utf-8,' + encodeURIComponent(errString)
      );

      pom.setAttribute('download', this.$t('personalMana.importFailErrFile'));
      if (document.createEvent) {
        var event = document.createEvent('MouseEvents');
        event.initEvent('click', true, true);
        pom.dispatchEvent(event);
      } else {
        pom.click();
      }
    },

    // 获取人员二维码
    async handleGetQRCode(data) {
      const vm = this;
      try {
        const res = await createQRCode({
          bindingTargetId: data.id,
          bindingType: 1,
          timeoutSeconds: 300
        })
        this.codeString = res.data.collection[0];
        this.codeName = data.name;
        setTimeout(() => {
          this.QRCodeModalVisible = true;
        }, 0)
      } catch (error) {}
    },

    // 解除绑定
    handleUnboundWx(data) {
      this.$confirm({
        title: this.$t('personalMana.unbindWarning'),
        content: this.$t('personalMana.unbindWarningDesc'),
        okText: this.$t('personalMana.confirmBtn'),
        cancelText: this.$t('personalMana.cancelBtn'),
        onOk: () => { this.unboundWx(data.id) },
        onCancel() {}
      });
    },

    async unboundWx(id) {
      try {
        await unbindWeChat({ id })
        this.getPersonalListData()
        this.$notification.success({
          message: this.$t('personalMana.unbindSuccess'),
          description: ''
        });
      } catch (error) {}
    }
  }
}
</script>

<style scoped>
</style>
